import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id CE74B9A9-5962-4127-ACBE-A1AD4F130A2F
 * name bookmark-off
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-off.svg
 * tags
 */
export const BookmarkOffIcon = createSvgIcon(<><path d="M20,20.72L18.73,22L16.78,20.05L12,18L5,21V8.27L2,5.27L3.28,4L20,20.72M19,17.16V5C19,3.89 18.1,3 17,3H7C6.41,3 5.89,3.27 5.5,3.68L19,17.16Z" /></>, 'BookmarkOffIcon');
export default BookmarkOffIcon